export const MAX_LABEL_LENGTH = 25;
export const MAX_SIGNED_OUT_PAGES = 9;
export const PRIVACY_POLICY_VERSION = 'privacy_policy_may_23';
export const IMAGES_PARTNERS = '/images/partners';
